import styled from "styled-components";

const ColTitle = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 30px;
    justify-content: center;

    >span:first-child{
        color: var(--blue);
        transition: 200ms ease;

        &:hover{
            cursor: pointer;
            text-decoration: underline;
            font-weight: bold;
        }
    }
`;

export default ColTitle;
